var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('header',[_c('span',{staticClass:"dummy"}),_c('h1',[_vm._v(_vm._s(_vm.showTitle))]),_c('span',{staticClass:"right-btn"},[_c('VButton',{ref:"CloseBtn",staticClass:"close-btn",class:{ mobile: _vm.isMobile },attrs:{"iconName":"close","type":"button","ui-type":"text"},on:{"click":_vm.closeClicked}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }